import loadable from '@loadable/component'
export const reviews = {
  variations: {
    default: loadable(() => import('./index.js'))
  },
  wrapperConfig: { useContainer: true },
  hydrate: false
}
